// Following script is to bind all of the '.add-cart-item' selected elements to trigger cart item addition of the product whose id will be passed
// using data-product-id

function addToCartEventListener(btns, event) {

  const networkType = navigator?.connection?.effectiveType;

  if (event && event.target && ['slow-2g', '2g', '3g'].includes(networkType)) {
    event.target.innerHTML = 'Adding to cart...';
    event.target.classList.value = `${event.target.classList.value} loading`;
  }

  const inputs = document.querySelectorAll('.add-item-quantity');

  let formData = {
    items: [],
  };

  const sellingPlanInputs = document.querySelectorAll('[data-sls-selling_plan]');
  const sellingPlanIds = [];
  if (sellingPlanInputs && sellingPlanInputs.length) {
    sellingPlanInputs.forEach(spInput => {
      if (spInput && spInput.value) {
        sellingPlanIds.push(spInput.value);
      }
    });
  }

  if (inputs && inputs.length) {
    inputs.forEach(input => {
      if (input && input.value > 0) {
        formData.items.push({
          id: input.dataset.productId,
          quantity: input.value,
          ...(sellingPlanIds.includes(input.dataset.sellingPlan) && { selling_plan: input.dataset.sellingPlan })
        });
      }
    })
  }

  if (formData && formData.items && !formData.items.length) {
    return;
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      updateCartUI();

      if (event && event.target  && ['slow-2g', '2g', '3g'].includes(networkType)) {
        event.target.innerHTML = 'Claim your early bird price';
        event.target.classList.value = `${event.target.classList.value.replace('loading', '')}`;
      }
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function addMultipleItemsToCartEventListener(btns, event) {

  const networkType = navigator?.connection?.effectiveType;

  if (event && event.target && ['slow-2g', '2g', '3g'].includes(networkType)) {
    event.target.innerHTML = 'Adding to cart...';
    event.target.classList.value = `${event.target.classList.value} loading`;
  }

  const rawInputs = document.querySelectorAll('.add-item-quantity');

  const inputs = [];
  rawInputs.forEach(rawInput => {
    if (rawInput.type.toLowerCase() !== 'radio' || rawInput.checked) {
      inputs.push(rawInput);
    }
  });

  let formData = {
    items: [],
  };

  const sellingPlanInputs = document.querySelectorAll('[data-sls-selling_plan]');
  const sellingPlanIds = [];
  if (sellingPlanInputs && sellingPlanInputs.length) {
    sellingPlanInputs.forEach(spInput => {
      if (spInput && spInput.value) {
        sellingPlanIds.push(spInput.value);
      }
    });
  }

  if (inputs && inputs.length) {
    inputs.forEach((input, index) => {
      if (input && input.value > 0) {
        if (!input.dataset.explicitly || (input.dataset.explicitly && input.dataset.sellingPlan)) {
          formData.items.push({
            id: input.dataset.productId,
            quantity: input.value,
            // sellingPlanIds -> All selling plan ids captured via input that are currently on the page.
            // input.dataset.sellingPlan -> will always be there for specific product if that product has sellingPlan available.
            // Following check handles two situtations:
            // 1. Selling plan is selected on the subscription product
            // 2. Selling plan is selected on any other product (auli 2.0), for which we are prioritizing explicitly which is false on the subscription product page.
            // But if we want to sell subscription product on the one time product page, then by setting explicitly we are forcing the subscription product if input.dataset.sellingPlan is available.
            ...((sellingPlanIds.includes(input.dataset.sellingPlan) || (input.dataset.explicitly && input.dataset.sellingPlan)) && { selling_plan: input.dataset.sellingPlan })
          });
        }
      }
    })
  }

  if (formData && formData.items && !formData.items.length) {
    return;
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      updateCartUI();

      if (event && event.target && ['slow-2g', '2g', '3g'].includes(networkType)) {
        event.target.innerHTML = 'Claim your early bird price';
        event.target.classList.value = `${event.target.classList.value.replace('loading', '')}`;
      }

      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// Multiple product addition buttons in cart

const listenerForMultipleItems = {
  previous: () => { },
  current: () => { },
};

function initializeAddToCartEvents() {

  const singleItemAddBtns = document.querySelectorAll('.add-cart-item');
  const listenerForSingleItem = addToCartEventListener.bind(this, singleItemAddBtns);
  // Single product addition in cart
  singleItemAddBtns.forEach((btn) => {
    btn.removeEventListener('click', listenerForSingleItem);
    btn.addEventListener('click', listenerForSingleItem);
  });


  const multipleItemsAddBtns = document.querySelectorAll('.add-cart-items');

  listenerForMultipleItems.current = addMultipleItemsToCartEventListener.bind(this, multipleItemsAddBtns);

  multipleItemsAddBtns.forEach((btn) => {
    btn.removeEventListener('click', listenerForMultipleItems.previous);
    btn.addEventListener('click', listenerForMultipleItems.current);
  });

  listenerForMultipleItems.previous = listenerForMultipleItems.current;
}

initializeAddToCartEvents();

// Update cart UI
function updateCartUI(cartShouldShow = true) {
  let sectionId = 'custom-header';
  const elementToReplace = document.querySelector('.custom-header-section');

  if (elementToReplace && elementToReplace.id) {
    sectionId = elementToReplace.id.replace('shopify-section-', '');
  }

  fetch(`${window.Shopify.routes.root}products/auli?section_id=${sectionId}&page_type=product`)
    .then(response => response.text())
    .then(html => {
      // Assuming your drawer container has this ID:
      const headers = document.querySelectorAll('.custom-header-section');

      // CRITICAL: Replace the inner HTML with the new content
      if (headers && headers.length) {
        headers.forEach(header => {
          const startDivIndex = html ? html.indexOf('>') : -1
          const lastDivIndex = html ? html.lastIndexOf('</div>') : -1;
          if (lastDivIndex > 0 && startDivIndex > 0) {
            htmlToEmbed = html.slice(startDivIndex + 1, lastDivIndex);
          }

          header.innerHTML = htmlToEmbed;
          const carouselContainer = header.querySelector('.owl-carousel');
          if (carouselContainer) {
            carouselContainer.setAttribute('style', 'display:block')
          }
        });
      }

      initializeCartEvents();
      initializeAddToCartEvents();
      initializeHeaderEvents();
      cartShouldShow && showCart();

    })
    .catch(error => console.error('Error fetching cart drawer section:', error));
}